<template>
  <div>
    <v-text-field
      :append-icon="visible ? 'visibility' : 'visibility_off'"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :disabled="disabled"
      :error="error"
      :error-messages="errorMessages"
      :label="label|capitalize"
      :name="name"
      :ref="name"
      placeholder=" "
      :required="passwordRequired"
      :type="visible ? 'text' : 'password'"
      :value="value"
      @blur="onBlur($event)"
      @click:append="visible = !visible"
      @focus="onFocus()"
      @input="onInput($event)"
      class="nx-form-text"
      data-vv-validate-on="input|blur"
      data-vv-value-path="value"
      v-validate="validation"
    ></v-text-field>
    <v-text-field
      v-if="confirmed"
      :disabled="disabled"
      :name="confirmName"
      :data-vv-name="confirmName"
      :error="error"
      :error-messages="errorMessages"
      label="Confirmar contraseña"
      :type="visible ? 'text' : 'password'"
      v-model="confirmValue"
      @focus="onFocus()"
      :ref="confirmName"
      class="nx-form-text"
    ></v-text-field>
  </div>
</template>

<script>
import isObject from 'lodash/isObject';
import FormText from './FormText';

export default {
  name: 'nx-form-password',
  extends: FormText,
  props: {
    error: Boolean,
  },
  data() {
    return {
      visible: false,
      confirmValue: null,
    };
  },
  computed: {
    confirmed() {
      if (this.validation === null) return false;
      if (isObject(this.validation)) {
        return this.validation.confirmed;
      }
      return this.validation.includes('confirmed');
    },
    passwordRequired() {
      return this.required || this.value;
    },
    confirmName() {
      return `${this.name}_confirmation`;
    },
  },
};
</script>
